import React from 'react'
import jQuery from 'jquery';

var EventFormAccommodationContainer = React.createClass({
  // propTypes: {
  //   fields: React.PropTypes.array
  // },
  componentDidUpdate: function() {
    jQuery(this.refs.root).find('.input-daterange').datepicker({
      format: 'yyyy-mm-dd',
      todayBtn: 'linked',
      autoclose: true,
      clearBtn: true
    })
    .on('changeDate', (e) => this.props.onChange({[e.target.name] : e.target.value}));
  },
  componentDidMount: function() {
    this.componentDidUpdate();
  },
  render: function() {
    const { onChange, accommodation } = this.props;
    return(
      <div ref="root" className="panel">
        <div className="panel-heading">
          <div className="panel-title"> <span className="glyphicons glyphicons-building"></span> Hotel Information </div>
        </div>
        <div className="panel-body">
          <div className="form-group">
            <label className="col-lg-2 control-label">Do you require hotel reservations?</label>
            <div className="col-lg-10">
              <label className="radio">
                <input className="radio" type="radio" name="required" value={true} checked={accommodation.required} onChange={ e => onChange({ required: true }) } />
                YES
              </label>
              <label className="radio">
                <input className="radio" type="radio" name="required" value={false} checked={!accommodation.required} onChange={ e => onChange({ required: false }) } />
                NO
              </label>
            </div>
          </div>
          { !accommodation.required ? undefined :
          <div>
            <div className="form-group">
              <label className="col-lg-2 control-label">Occupancy</label>
              <div className="col-lg-10">
                <label className="radio">
                  <input className="radio" type="radio" name="occupancy" value='single' checked={accommodation.occupancy == 'single'} onChange={ e => onChange({ occupancy: 'single' }) } />
                  Single
                </label>
                <label className="radio">
                  <input className="radio" type="radio" name="occupancy" value='double' checked={accommodation.occupancy == 'double'} onChange={ e => onChange({ occupancy: 'double' }) } />
                  Double
                </label>
              </div>
            </div>
            <div className="form-group">
              <label className="col-lg-2 control-label">Date of check in / check out</label>
              <div className="col-lg-10">
                <div className="input-group input-daterange">
                  <span className="input-group-addon"><i className="glyphicons glyphicons-calendar"></i></span>
                  <input type="text" name="checkin_date" className="form-control margin-top-none" value={accommodation.checkin_date} />
                  <span className="input-group-addon">to</span>
                  <input type="text" name="checkout_date" className="form-control margin-top-none" value={accommodation.checkout_date} />
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    );
  }
});

export default EventFormAccommodationContainer;


// WEBPACK FOOTER //
// ./src/components/event_form_accommodation_container.js